import React from "react";
import { Children } from "react";

import "./Input.css";

export const Input = (
  {
    inputName,
    labelText,
    type,
    value,
    defaultValue,
    placeholder,
    disabled,
    error,
    className,
    id,
    children,

    inputValueHandler,
    inputBlurHandler,
  }) => {

  const inputConstructor = () => {
    return <input 
      type={type ? type : 'text'}
      name={inputName}
      disabled={disabled && disabled}
      placeholder={placeholder ? placeholder : ''}
      value={value}
      defaultValue={defaultValue && defaultValue}
      className={'default-input ' + (error ? "error " : "")}
      id={id && id}

      onChange={(e) => {
        e.preventDefault();
  
        inputValueHandler && inputValueHandler(e.target.value)
      }}

      onBlur={(e) => {
        e.preventDefault();

        inputBlurHandler && inputBlurHandler(e.target.value)
      }}
    />
  }

  return (
    <div
      className={
        "input" + (disabled ? " disabled" : "") + (error ? " inputError" : "") + (className ? (' ' + className) : "")
      }
    >
      {labelText && (
        <div className="label-wrapper">
          <label htmlFor={labelText}>{labelText}</label>
        </div>
      )}

      <div className='input-wrapper'>
        {inputConstructor()}
        {children && children}
      </div>

      {error && <p className="Input_error error">{error}</p>}
    </div>
  );
};
